var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.804 18.2129C17.299 17.7119 14.715 17.7739 12.237 18.3929L12 18.4529C9.366 19.1109 6.619 19.1769 3.957 18.6439L3.804 18.6129C3.336 18.5199 3 18.1089 3 17.6329V6.7939C3 6.1629 3.577 5.6899 4.196 5.8129C6.701 6.3139 9.285 6.2519 11.763 5.6329L12.236 5.5149C14.714 4.8959 17.299 4.8339 19.803 5.3349L20.195 5.4129C20.664 5.5069 21 5.9169 21 6.3939V17.2329C21 17.8639 20.423 18.3369 19.804 18.2129Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25488 12.001H12.7479",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8906 14.655C12.8296 15.115 11.5576 14.926 10.6906 14.058C9.55364 12.921 9.55364 11.078 10.6906 9.94104C11.5586 9.07304 12.8306 8.88404 13.8906 9.34404",
    stroke: "#F1F3F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.a6ced7287940faa0d5fc416e85e211ec.svg";
export { ForwardRef as ReactComponent };